import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isOwnerToolsUser } from '../../utils/ownerTools';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import './SubNav.css';

const SubNav = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const showOwnerTools = isOwnerToolsUser(user);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="dashboard-nav">
      <div className="dashboard-nav-content">
        <NavLink to="/" title="Home" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">🔮</span>
          <span className="nav-text">Home</span>
        </NavLink>
        {showOwnerTools && (
          <NavLink to="/llm" title="LLM" className={({ isActive }) => isActive ? 'active' : ''}>
            <span className="nav-icon">✨</span>
            <span className="nav-text">LLM</span>
          </NavLink>
        )}
        {showOwnerTools && (
          <NavLink to="/translate" title="Translate" className={({ isActive }) => isActive ? 'active' : ''}>
            <span className="nav-icon">🌐</span>
            <span className="nav-text">Translate</span>
          </NavLink>
        )}
        {user?.calling_enabled && (
          <NavLink to="/wallet" title="Wallet" className={({ isActive }) => isActive ? 'active' : ''}>
            <span className="nav-icon">💳</span>
            <span className="nav-text">Wallet</span>
          </NavLink>
        )}
        <NavLink to="/account" title="Settings" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">⚙️</span>
          <span className="nav-text">Settings</span>
        </NavLink>
        <NavLink to="/support" title="Help" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">💬</span>
          <span className="nav-text">Help</span>
        </NavLink>
        <button
          className="nav-logout"
          title="Logout"
          onClick={handleLogout}
        >
          <span className="nav-icon">🚪</span>
          <span className="nav-text">Logout</span>
        </button>
        <div className="nav-theme-slot">
          <ThemeToggle />
        </div>
      </div>
    </nav>
  );
};

export default SubNav;
